export const basemapExtent = [977650, 5838030, 1913530, 6281290];

// Shared circle scale for haChart/vfmChart map symbols and legend.
export const DIAGRAM_MAX_RADIUS = 50;
export const DIAGRAM_MAX_HA = 32100; // Dürre- und Hitzschäden, Horn, 2019
export const DIAGRAM_MAX_VFM = 1455250; // Windwurf,- bruch, 2008, Graz-Umgebung

export const MARKDOWN_CONFIG = {
  html: true,
  linkify: true,
  breaks: true,
};
